import teacherConstants from '../constants/teacherConstants';

const initialState = {
  teachers: [],
};

export default function teacher(state = initialState, action) {
  switch (action.type) {
    case teacherConstants.GET_TEACHERS_REQUEST:
      return {
        ...state,
        requesting: true,
      };
    case teacherConstants.GET_TEACHERS_SUCCESS:
      return {
        ...state,
        requesting: false,
        teachers: action.teachers,
      };
    case teacherConstants.GET_TEACHERS_FAILURE:
      return {
        ...state,
        requesting: false,
      };
    default:
      return state;
  }
}
